<template>
  <DialogContainer
    :showDialog="showDialog"
    :isLoading="isLoading"
    type="confirmation"
    :toolbarActions="[
      {
        text: submitButtonText,
        icon: submitButtonIcon,
        buttonColor: submitButtonColor,
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
      },
      {
        text: cancelButtonText,
        depressed: true,
        isVisibleFunc: () => !!showCancelButton,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="$emit('onCancelClicked')"
    @onSubmitClicked="$emit('onSubmitClicked')"
  >
    <v-container pa-0 grid-list-lg>
      <v-layout wrap>
        <v-flex xs12>
          {{ message }}
        </v-flex>
      </v-layout>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'

export default {
  components: {
    DialogContainer,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    submitButtonText: {
      type: String,
      default: 'Confirm',
    },
    submitButtonIcon: {
      type: String,
    },
    submitButtonColor: {
      type: String,
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },
    showCancelButton: {
      type: Boolean,
    },
  },
  data: () => ({
    isFormValid: false,
  }),
  methods: {},
}
</script>